import { useNavigate } from "react-router-dom";
import { getData, removeData } from "../../utiles/CookieUtile";
import { createToken } from "../../services/authService";
import ErrorMsg from "../messages/Errormessage";
import useShowAlert from "../../utiles/AlertUtiles";
const useErrorHandle = () => {
  const navigate = useNavigate();
  const showAlert = useShowAlert();
  const handleError = async (error) => {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401 && data?.code === "TOKEN_EXPIRED") {
        const refreshToken = getData("refreshToken");
        try {
          const tokenCreated = await createToken(refreshToken);
          if (!tokenCreated) {
            console.log("No refresh token available");
            navigate("/login");
          }
          return;
        } catch (err) {
          console.error("Failed to create token:", err);
          showAlert("error", "Failed to refresh token. Please log in again.");
          navigate("/login");
          return;
        }
      } else if (status === 404) {
        if (
          (data.status === true || data.status === false) &&
          data.statusCode === 404 &&
          data.code === "NOT_FOUND"
        ) {
          return;
        }

        if (data.message === "No store were found for this account.") {
          console.log("404: Resource not found, verifying token...");
          removeData("refreshToken");
          navigate("/login");
          return;
        }
      } else if (status === 422) {
        console.log("422 Validation Error:", data);
        showAlert("warning", data?.message || "Validation error occurred.");
        return;
      } else if (status === 500) {
        console.log("500 Server Error:", data);
        showAlert(
          "error",
          data?.message || "An internal server error occurred."
        );
        return;
      } else if (status === 406) {
        showAlert(
          "error",
          "Not acceptable. Please check the request parameters."
        );
        return;
      } else if (status >= 500) {
        showAlert("error", "Server error. Please try again later.");
        return;
      } else {
        showAlert("warning", data?.message || "An unknown error occurred.");
        return;
      }
    }

    if (error.message === "NO_INTERNET") {
      showAlert("error", ErrorMsg.NO_INTERNET);
    } else if (error.code === "ERR_NETWORK") {
      showAlert("error", ErrorMsg.SERVER_DOWN);
    } else if (error.name === "AbortError") {
      showAlert("info", "Request was cancelled.");
    } else if (error.code === "ERR_BAD_REQUEST") {
      showAlert("warning", ErrorMsg.URL_NOT_FOUND);
    } else {
      showAlert("warning", error.message || ErrorMsg.SERVER_ERROR);
    }
  };

  return handleError;
};

export default useErrorHandle;
